import { render, staticRenderFns } from "./PermissionMapper.vue?vue&type=template&id=5e4b3d34"
import script from "./PermissionMapper.vue?vue&type=script&lang=js"
export * from "./PermissionMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports